module.exports = __webpack_public_path__ + "assets/img/coming-soon.52b5b46f.png";